import { render, staticRenderFns } from "./LogosSection.vue?vue&type=template&id=da4fde76&scoped=true&"
import script from "./LogosSection.vue?vue&type=script&lang=js&"
export * from "./LogosSection.vue?vue&type=script&lang=js&"
import style0 from "./LogosSection.vue?vue&type=style&index=0&id=da4fde76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4fde76",
  null
  
)

export default component.exports